import { computed } from 'vue';
import i18n, { EN, ZH } from '@/locales';


export function getContactList() {
    const isEN = computed(() => i18n.locale === EN);
    const isZH = computed(() => i18n.locale === ZH);
    const contactList = [
        {
            label: isZH.value ? '联系电话' : isEN.value ? 'Phone' : '聯絡電話',
            value: '0571-89055921',
            iconName: 'contact-icon-phone',
            isAddress: false
        },
        {
            label: isZH.value ? '电子邮箱' : isEN.value ? 'Email' : '電子郵箱',
            value: 'ir@diagens.com',
            iconName: 'contact-icon-email',
            isAddress: false
        },
        {
            label: isZH.value ? '办公地址' : isEN.value ? 'Address' : '辦公地址',
            value: isZH.value
                ? '浙江省杭州市临平区红丰路609号杭州智能.健康谷A幢9楼'
                : isEN.value
                    ? '9/F, Building A, Hangzhou Intelligent & Health Valley, No.609 Hongfeng Road, Linping District, Hangzhou, Zhejiang Province'
                    : '浙江省杭州市臨平區紅豐路609號杭州智能.健康谷A幢9樓',
            iconName: 'contact-icon-address',
            isAddress: true
        }
    ];

    return {
        contactList,
        isEN,
        isZH
    }

}